import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import styles from './index.less';
export var UICheckbox = function (props) {
    var id = props.id, _a = props.style, style = _a === void 0 ? {} : _a, className = props.className, _b = props.checked, checked = _b === void 0 ? false : _b, onChange = props.onChange, onClick = props.onClick;
    var checkstyle = checked ? 'checked' : 'unchecked';
    var View = useComponents().View;
    var onClickHandler = function () {
        onClick === null || onClick === void 0 ? void 0 : onClick();
        onChange === null || onChange === void 0 ? void 0 : onChange(!checked);
    };
    return (React.createElement(View, { id: id, className: styles['checkbox-container'] + " " + className, onClick: onClickHandler, style: style },
        React.createElement(View, { className: styles['checkbox-common'] + " " + styles["checkbox-box-" + checkstyle] }, checked && (React.createElement(View, null,
            React.createElement(View, { className: styles['checkbox-checked-mark-left'] }),
            React.createElement(View, { className: styles['checkbox-checked-mark-right'] })))),
        React.createElement(View, { className: styles['checkbox-content'] }, props.children)));
};
